/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for CreditNoteResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetCreditNoteByIdResponse, GetOutgoingCreditNotesResponse, GetIncomingCreditNotesResponse, CreditNoteStateId, GetCreditNoteResponse, GetCreditNoteAccountingOperationsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CreditNoteResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getCreditNoteById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetCreditNoteByIdResponse, unknown> & { defaultValue: NoInfer<GetCreditNoteByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCreditNoteByIdResponse>;
    getCreditNoteById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCreditNoteByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCreditNoteByIdResponse | undefined>;
    getCreditNoteById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCreditNoteByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCreditNoteByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/CreditNote/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getOutgoingCreditNotes(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions: HttpResourceOptions<GetOutgoingCreditNotesResponse, unknown> & { defaultValue: NoInfer<GetOutgoingCreditNotesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetOutgoingCreditNotesResponse>;
    getOutgoingCreditNotes(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions?: HttpResourceOptions<GetOutgoingCreditNotesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetOutgoingCreditNotesResponse | undefined>;
    getOutgoingCreditNotes(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions?: HttpResourceOptions<GetOutgoingCreditNotesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetOutgoingCreditNotesResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const startDateValue = typeof startDate === 'function' ? startDate() : startDate;
            if (startDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, startDateValue, 'startDate');
            }
            const endDateValue = typeof endDate === 'function' ? endDate() : endDate;
            if (endDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, endDateValue, 'endDate');
            }
            return {
                url: `${this.basePath}/CreditNote/Outgoing`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getIncomingCreditNotes(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions: HttpResourceOptions<GetIncomingCreditNotesResponse, unknown> & { defaultValue: NoInfer<GetIncomingCreditNotesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetIncomingCreditNotesResponse>;
    getIncomingCreditNotes(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions?: HttpResourceOptions<GetIncomingCreditNotesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetIncomingCreditNotesResponse | undefined>;
    getIncomingCreditNotes(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions?: HttpResourceOptions<GetIncomingCreditNotesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetIncomingCreditNotesResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const startDateValue = typeof startDate === 'function' ? startDate() : startDate;
            if (startDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, startDateValue, 'startDate');
            }
            const endDateValue = typeof endDate === 'function' ? endDate() : endDate;
            if (endDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, endDateValue, 'endDate');
            }
            return {
                url: `${this.basePath}/CreditNote/Incoming`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getCreditNotes(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, customerIds: Signal<Array<number>> | Array<number>, stateNames: Signal<Array<CreditNoteStateId>> | Array<CreditNoteStateId>, legalEntityIds: Signal<Array<number>> | Array<number>, search: Signal<string | null | undefined> | string | null | undefined, resourceOptions: HttpResourceOptions<GetCreditNoteResponse, unknown> & { defaultValue: NoInfer<GetCreditNoteResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCreditNoteResponse>;
    getCreditNotes(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, customerIds: Signal<Array<number>> | Array<number>, stateNames: Signal<Array<CreditNoteStateId>> | Array<CreditNoteStateId>, legalEntityIds: Signal<Array<number>> | Array<number>, search?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetCreditNoteResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCreditNoteResponse | undefined>;
    getCreditNotes(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, customerIds: Signal<Array<number>> | Array<number>, stateNames: Signal<Array<CreditNoteStateId>> | Array<CreditNoteStateId>, legalEntityIds: Signal<Array<number>> | Array<number>, search?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetCreditNoteResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCreditNoteResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const startDateValue = typeof startDate === 'function' ? startDate() : startDate;
            if (startDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, startDateValue, 'startDate');
            }
            const endDateValue = typeof endDate === 'function' ? endDate() : endDate;
            if (endDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, endDateValue, 'endDate');
            }
            const searchValue = typeof search === 'function' ? search() : search;
            if (searchValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchValue, 'search');
            }
            const customerIdsValue = typeof customerIds === 'function' ? customerIds() : customerIds;
            if (customerIdsValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, customerIdsValue, 'customerIds');
            }
            const stateNamesValue = typeof stateNames === 'function' ? stateNames() : stateNames;
            if (stateNamesValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, stateNamesValue, 'stateNames');
            }
            const legalEntityIdsValue = typeof legalEntityIds === 'function' ? legalEntityIds() : legalEntityIds;
            if (legalEntityIdsValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, legalEntityIdsValue, 'legalEntityIds');
            }
            return {
                url: `${this.basePath}/CreditNote`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getCreditNotesPeppolFile(uuids: Signal<Array<string>> | Array<string>, resourceOptions: HttpResourceOptions<Blob, Blob> & { defaultValue: NoInfer<Blob> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob>;
    getCreditNotesPeppolFile(uuids: Signal<Array<string>> | Array<string>, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined>;
    getCreditNotesPeppolFile(uuids: Signal<Array<string>> | Array<string>, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined> {
        return httpResource.blob(() => {
            let params = new HttpParams();
            const uuidsValue = typeof uuids === 'function' ? uuids() : uuids;
            if (uuidsValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, uuidsValue, 'uuids');
            }
            return {
                url: `${this.basePath}/CreditNote/PeppolFile`,
                method: "GET",
                params,
                responseType: 'blob' as 'blob',
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getCreditNotesAttachments(uuids: Signal<Array<string>> | Array<string>, resourceOptions: HttpResourceOptions<Blob, Blob> & { defaultValue: NoInfer<Blob> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob>;
    getCreditNotesAttachments(uuids: Signal<Array<string>> | Array<string>, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined>;
    getCreditNotesAttachments(uuids: Signal<Array<string>> | Array<string>, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined> {
        return httpResource.blob(() => {
            let params = new HttpParams();
            const uuidsValue = typeof uuids === 'function' ? uuids() : uuids;
            if (uuidsValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, uuidsValue, 'uuids');
            }
            return {
                url: `${this.basePath}/CreditNote/Attachments`,
                method: "GET",
                params,
                responseType: 'blob' as 'blob',
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getCreditNotePdf(id: Signal<number> | number, resourceOptions: HttpResourceOptions<Blob, Blob> & { defaultValue: NoInfer<Blob> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob>;
    getCreditNotePdf(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined>;
    getCreditNotePdf(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined> {
        return httpResource.blob(() => {
            return {
                url: `${this.basePath}/CreditNote/${typeof id === 'function' ? id() : id}/Pdf`,
                method: "GET",
                responseType: 'blob' as 'blob',
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getCreditNoteAccountingOperations(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetCreditNoteAccountingOperationsResponse, unknown> & { defaultValue: NoInfer<GetCreditNoteAccountingOperationsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCreditNoteAccountingOperationsResponse>;
    getCreditNoteAccountingOperations(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCreditNoteAccountingOperationsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCreditNoteAccountingOperationsResponse | undefined>;
    getCreditNoteAccountingOperations(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCreditNoteAccountingOperationsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCreditNoteAccountingOperationsResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/CreditNote/${typeof id === 'function' ? id() : id}/AccountingOperations`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
